import { aiHttpClient as AiHttpClient } from '../../../../Common/api/ai_http_client';

/**
 *
 * @param obj
 * @returns {string}
 */
function convertObjectToQueryString(obj) {
  let string = '';
  Object.keys(obj).forEach((item) => {
    if (obj[item] !== '') {
      string += `&${item}=${obj[item]}`;
    }
  });

  return string;
}

/**
* @async
* @function getAllRFMAnalysis
* @summary return HTTP GET request instance to /rfm/
* @since 0.1.0
* @returns {Promise} HTTP GET method
*/
export function getAllRFMAnalysis(options) {
  return AiHttpClient.get(`/rfm?limit=${options.limit}&page=${options.page}${convertObjectToQueryString(options.filters)}`);
}

/**
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchRfmCounts() {
  return AiHttpClient.get('/rfm/counts');
}

/**
 *
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchCustomer(id) {
  return AiHttpClient.get(`/customers/${id}`);
}

/**
 *
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchCustomerRFM(id) {
  return AiHttpClient.get(`/rfm/customer/${id}`);
}
